// Slightly darker than Phoenix's default primary color
export const PRIMARY_COLOR_OVERRIDE = '#5641F5'
